import { apiRequest } from "./api";

export function listMyMemberPromotions() {
  return apiRequest("/api/v1/me/member-promotions");
}

export function claimMyMemberPromotion(code) {
  return apiRequest(`/api/v1/me/member-promotions/${encodeURIComponent(code)}/claim`, {
    method: "POST",
    body: JSON.stringify({}),
  });
}

export function listAdminMemberPromotions() {
  return apiRequest("/api/v1/admin/member-promotions");
}

export function saveAdminMemberPromotion(payload) {
  return apiRequest("/api/v1/admin/member-promotions", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}
